function fn_layout_footer() {
    var $fn = $("#layout_footer");
    if ($fn.length) {
        $fn.on("click",".icon--nl_logo",function (e) {
            e.preventDefault();
            $(this).toggleClass("mod--active");
        });
    }
}